import React from 'react';
import { Layout, message, Modal, Icon, Button } from 'antd';
import NHContainerFrame from "../../../common/NHContainerFrame/index";
import NHTable from "../../../common/NHTable/index";
import { NHModal } from '../../../common/NHModal';
import getSize from "../../../../utils/getSize";
import NHFetch from "../../../../utils/NHFetch";
import {hasAuth} from "../../../../utils/NHCore";
import EditForm from './EditForm.js';
const confirm = Modal.confirm;


const { Content } = Layout;

export default class QueryStudents extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            searchParams: {},
            selectKey: '',
            showData: {}, //修改的数据
            showAdd: false,
            showListPage: true,
            isAdd: true,
            showOperationBtn: false,
            showQxbdButton: false,
            formInitData: {},
        }
    }

    //搜索框条件值改变时调用的方法
    inputChange = (param) => {
        let searchParams = this.state.searchParams;
        let name = param.target.name;
        searchParams[name] = param.target.value;
        this.setState({
            searchParams: searchParams
        });
    }

    //新增面板保存方法
    handleSaveAdd = (stopLoading) => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            if (err) {
                stopLoading();
                return;
            }
            if (this.state.isAdd) {
                NHFetch('/wbdStudentMng/insert', 'POST', formData)
                    .then(res => {
                        if (res) {
                            message.success("操作成功！");
                            this.refs.nhAddModal.close();
                            this.refs.nhTable.filterTableData();
                            this.setState({
                                showQxbdButton: false
                            })
                        }
                        stopLoading();
                    }).catch(err => stopLoading());
            } else {
                NHFetch('/wbdStudentMng/update', 'POST', formData)
                    .then(res => {
                        if (res) {
                            message.success("操作成功！");
                            this.refs.nhAddModal.close();
                            this.refs.nhTable.filterTableData();
                            this.setState({ 
                                isAdd: true,
                                showQxbdButton: false
                            });
                        }
                        stopLoading();
                    }).catch(err => stopLoading());
            }

        });
    }

    onSelect = (key, rowObj) => {
        if(rowObj.length == 1) {
            this.setState({
                showQxbdButton: true
            })
        }else {
            this.setState({
                showQxbdButton: false
            })
        }
    }

    handleCancelReportBtnClick = () => {
        //该字段判断未报到表是否有数据 0没有1有
        let recode = this.refs.nhTable.state.selectedRows[0];
        let haswbc = recode.HASWBD == 0 ? true : false;
        this.setState({
            isAdd: haswbc,
            formInitData: recode
        }, () => { this.refs.nhAddModal.show() });
    }

    exportClickListener = (tar) => {
        tar.exportExcel('学生信息查询');
    };

    render() {
        let columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '70',
                cacheFixed: 'left'
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120',
                cacheFixed: 'left',
                search: 'input',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '100',
                cacheFixed: 'left',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '100',
                search: 'input',
                searchType:"select"
            }, {
                title: '学院名称',
                dataIndex: 'BMMC',
                width: '200',
                search: 'input',
                searchType:"select"
            }, {
                title: '专业名称',
                dataIndex: 'ZYMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级名称',
                dataIndex: 'BJMC',
                width: '200',
                search: 'input',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '身份证件号',
                dataIndex: 'SFZJH',
                width: '180',
                search: 'input',
                searchType:"input"
            }, {
                title: '学生类别',
                dataIndex: 'XSLB',
                width: '120',
                search: 'input',
                searchType:"select"
            }, {
                title: '考生号',
                dataIndex: 'KSH',
                width: '150',
                search: 'input',
                searchType:"input"
            }, {
                title: '省',
                dataIndex: 'PROVINCE',
                width: '80',
                search: 'input',
                searchType:"input"
            } , {
                title: '市',
                dataIndex: 'CITY',
                width: '80',
                search: 'input',
                searchType:"input"
            } , {
                title: '区',
                dataIndex: 'DISTRICT',
                width: '80',
                search: 'input',
                searchType:"input"
            } ,{
                title: '手机号码',
                dataIndex: 'SJHM',
                width: '120',
                search: 'input',
                searchType:"input"
            }, {
                title: '是否缴费',
                dataIndex: 'SFJF',
                width: '120',
                search: 'input',
                filters: [{ text: '是', value: '是' }, { text: '否', value: '否' }],
                searchType:"select"
            }, ,{
                title: '未报到原因',
                dataIndex: 'WBDYY',
                width: '120',
                search: 'input',
                searchType:"input"
            }, {
                title: '是否报到',
                dataIndex: 'SFBD',
                width: '120',
                search: 'input',
                cacheFixed: 'right',
                filters: [{ text: '是', value: '是' }, { text: '否', value: '否' }],
                searchType:"select"
                // cacheFixed: 'right',
                // render: (value) => {
                //     return value == '是' ? <Icon type="check-circle" style={{fontSize: 16, color: '#53c41a'}}/>
                //         : <Icon type="close-circle" style={{fontSize: 16, color: '#ff4d4f'}}/>;
                // }
            }
        ];
        return (
            <div>
                <Layout style={{ height: '100%' }}>
                    {this.state.showListPage == true && <Layout>
                        <Layout >
                            <Content style={{ margin: '12px', marginBottom: '0px', padding: '12px', background: '#fff', minHeight: 280, height: getSize().windowH - 123 }}>
                                <div style={{ width: '100%', height: '100%', }}>
                                   <NHTable
                                        ref='nhTable'
                                        rowKey={record => record.XSID}
                                        sign={"zhxg_yxxt_newStudentInfo_queryPage_scjt"}
                                        columns={columns}
                                        initParams={this.state.searchParams}
                                        onSelect={this.onSelect}
                                        rangeFilter={true}>
                                        {hasAuth("zhxg_yxgl_tjcx_xsxxcx:export") &&
                                        <Button type="primary" ghost onClick={() => this.exportClickListener(this.refs.nhTable)}
                                                style={{marginLeft: 10}}>导出</Button>}
                                        <Button type="primary" ghost 
                                                style={{marginLeft: 10, display: this.state.showQxbdButton ? undefined : 'none'}} 
                                                onClick={this.handleCancelReportBtnClick}>取消报到</Button> 
                                    </NHTable>
                                </div>
                                <NHModal ref="nhAddModal"
                                    title="取消报到"
                                    onOk={this.handleSaveAdd}
                                >
                                    <EditForm ref="nhAddForm" initFormData={this.state.formInitData} />
                                </NHModal>
                            </Content>
                        </Layout>
                    </Layout>}
                </Layout >
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/queryStudents/scjtQueryStudents/index.js